import { render, staticRenderFns } from "./kelompok.vue?vue&type=template&id=c4149650&"
import script from "./kelompok.vue?vue&type=script&lang=js&"
export * from "./kelompok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports